<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16.701 9.652"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7.772V4.05a.771.771 0 1 1-1.542 0V2.632L9.426 8.364a.77.77 0 0 1-1.09 0L5.357 5.385l-4.031 4.03A.774.774 0 0 1 0 8.873a.77.77 0 0 1 .235-.548L4.81 3.749c.302-.3.79-.3 1.09 0l2.98 2.98 5.189-5.187h-1.419a.771.771 0 0 1 0-1.542h3.28a.772.772 0 0 1 .77.77l.002.002z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
